<ng-container *ngIf="activeFacets$ | async as facets">
  <div *ngIf="facets?.length > 0"
       class="row mb-2 no-gutters"
  >
    <div class="col-12 mb-active-facets"
         data-cy="cms-active-facets"
    >
      <div *ngIf="facets?.length > 0"
           [innerHTML]="'searchFilterPane.filteredBy' | cxTranslate"
           class="my-2 mr-4 d-block d-md-inline mb-active-facets-label"
           data-cy="cms-active-facets-label"
      ></div>

      <ng-container *ngFor="let facet of facets, index as i">
        <ng-container *ngIf="i !== 0">
          <div class="mr-3 mb-2 mb-active-facet-term"
               data-cy="cms-active-facet-term-and"
          >
            <div [innerHTML]="'searchFilterPane.and' | cxTranslate"
                 data-cy="cms-active-facets-and-text"
            ></div>
          </div>
        </ng-container>

        <ng-container *ngFor="let facetCount of facet?.counts; index as j">
          <ng-container *ngIf="j !== 0">
            <div class="mr-3 mb-2 mb-active-facet-term"
                 data-cy="cms-active-facet-term-or"
            >
              <div [innerHTML]="'searchFilterPane.or' | cxTranslate"
                   class="mb-active-facet-item-text"
                   data-cy="cms-active-facets-or-text"
              ></div>
            </div>
          </ng-container>

          <div class="mr-3 mb-2 mb-active-facet-item"
               data-cy="cms-active-facet-item"
          >
            <mb-link *ngIf="!isReadonlyFacet(facetCount)"
                     [linkData]="{uid: cmsLinkType.SPECIAL}"
                     [queryParams]="getQueryParam(facetCount)"
                     [useSlot]="true"
                     [styleClass]="['text-decoration-none', 'd-inline mb-active-facet-item-icon']"
                     (click)="onRemoveFacetClick()"
                     dataCy="cms-active-facets-remove-btn"
                     routerLink="./"
            >
              <span [innerHTML]="getFacetCategoryName(facet) + ' - ' + (facetCount?.value ?? '') | safeHtml"
                    class="d-inline mb-active-facet-item-text"
                    data-cy="cms-active-facet-item-text"
              ></span>
            </mb-link>
            <mb-link *ngIf="isReadonlyFacet(facetCount)"
                     [linkData]="{uid: cmsLinkType.SPECIAL}"
                     [useSlot]="true"
                     [styleClass]="['text-decoration-none', 'd-inline', 'mb-active-facet-item-icon', 'read-only-facet']"
                     dataCy="cms-active-facets-remove-btn"
            >
              <span [innerHTML]="getFacetCategoryName(facet) + ' - ' + (facetCount?.value ?? '') | safeHtml"
                    class="d-inline mb-active-facet-item-text"
                    data-cy="cms-active-facet-item-text"
              ></span>
            </mb-link>
          </div>
        </ng-container>
      </ng-container>
    </div>
  </div>
</ng-container>
